module.exports = __webpack_public_path__ + "img/trans.9ac221d4.png";